var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M34.2,31.5h-0.7c-0.6,0.4-1,1.1-1,1.8c0.6,0,1.3-0.2,1.7-0.7C34.6,32.3,34.5,31.9,34.2,31.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M20.4,19.1h13.3c1.5,0,2.8-1.3,2.8-2.8v-5.7c-0.1-1.5-1.3-2.7-2.8-2.8h-2.5h-3.8h-3.1 c-1.6,0-2.8,1.2-2.9,2.8v5l-1.7,1.7c-0.4,0.3-0.5,0.8-0.3,1.2C19.6,18.9,20,19.1,20.4,19.1z M20.4,18l2-2v-5.4 c0.1-1,0.9-1.8,1.9-1.8h9.4c1,0,1.8,0.8,1.8,1.8v5.7c0,1-0.8,1.8-1.8,1.8H20.3C20.3,18,20.3,18,20.4,18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4AB8DC",
  d: "M35.5,16.3v-5.7c0-1-0.8-1.8-1.8-1.8h-9.4c-1,0-1.8,0.8-1.9,1.8V16l-2,2c-0.1,0-0.1,0-0.1,0.1h13.4 C34.7,18.1,35.5,17.3,35.5,16.3z M25.8,14.6c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S26.6,14.6,25.8,14.6z  M29.3,14.6c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S30.1,14.6,29.3,14.6z M31.4,13.2c0-0.8,0.6-1.4,1.4-1.4 s1.4,0.6,1.4,1.4s-0.6,1.4-1.4,1.4S31.4,14,31.4,13.2z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 25.8,
  cy: 13.2,
  r: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 29.3,
  cy: 13.2,
  r: 1.4
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 32.8,
  cy: 13.2,
  r: 1.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M32.6,34.3c0.9,0,1.8-0.4,2.4-1c0.6-0.7,0.6-1.8-0.1-2.5c-0.5-0.5-1.3-0.6-1.9-0.2 c-0.9,0.6-1.4,1.6-1.5,2.7c-0.8-0.1-1.6-0.5-2.2-1l-1.9-2l0.5-0.4l0.3-0.3c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.2,1-0.4 c0.6-0.5,0.6-1.4,0-2c0,0,0,0,0,0l-5.8-5.7c-0.2-0.3-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.1-1,0.4c-0.5,0.4-0.5,1.2-0.1,1.7c0,0,0,0,0,0 c-0.4,0.4-1.1,0.5-1.6,0.2c-1-0.6-1.9-1.4-2.7-2.2c-1-1-1.8-2.1-2.5-3.3c-0.3-0.4-0.2-1,0.1-1.4c0.2,0.2,0.5,0.3,0.8,0.3 c0.3,0,0.7-0.1,0.9-0.4c0.3-0.3,0.4-0.6,0.4-1c0-0.3-0.1-0.7-0.4-0.9L11.5,9c-0.3-0.3-0.6-0.4-1-0.4c-0.4,0-0.7,0.1-1,0.4 C9,9.5,9,10.3,9.4,10.8H9.3C8,12.2,7.5,14.2,8,16c1.2,3.6,3.2,6.8,5.9,9.5c2.4,2.5,5.4,4.4,8.7,5.6c0.5,0.2,1.1,0.3,1.7,0.3 c0.8,0,1.5-0.2,2.2-0.5l2.2,2.1c0.8,0.7,1.8,1.2,2.8,1.3c0.3,1.1,1.4,2.8,5.7,2.8v-1C34.6,36.2,33,35.6,32.6,34.3z M23,22.5h0.5 l5.8,5.7c0.1,0.2,0.1,0.4,0,0.6c-0.2,0.1-0.3,0.1-0.5,0l-3.9-3.9L23,23C22.9,22.9,22.9,22.6,23,22.5z M10.2,9.7h0.6l5.7,5.8 c0.2,0.1,0.2,0.3,0,0.5c-0.2,0.1-0.3,0.1-0.5,0l-5.8-5.8V10C10.1,9.9,10.2,9.8,10.2,9.7z M22.9,30.1c-3.1-1.1-6-2.9-8.3-5.3 c-2.6-2.5-4.5-5.7-5.6-9.1c-0.5-1.4-0.1-3,1-4.1h0.1l4.6,4.5c-0.6,0.7-0.7,1.8-0.2,2.6c0.7,1.3,1.6,2.5,2.7,3.5 c0.9,0.9,1.8,1.7,2.9,2.3c0.3,0.3,0.8,0.4,1.2,0.4c0.6,0,1.2-0.2,1.6-0.6l2.3,2.3l2.3,2.3l-0.3,0.3C26.1,30.3,24.4,30.7,22.9,30.1z  M33.5,31.5h0.7c0.3,0.4,0.4,0.8,0,1.1c-0.4,0.5-1.1,0.7-1.7,0.7C32.5,32.6,32.9,31.9,33.5,31.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M25.2,26.6l-2.3-2.3c-0.4,0.4-1,0.6-1.6,0.6c-0.4,0-0.9-0.1-1.2-0.4c-1.1-0.6-2-1.4-2.9-2.3 c-1.1-1-2-2.2-2.7-3.5c-0.5-0.8-0.4-1.9,0.2-2.6l-4.6-4.5H10c-1.1,1.1-1.5,2.7-1,4.1c1.1,3.4,3,6.6,5.6,9.1 c2.3,2.4,5.2,4.2,8.3,5.3c1.5,0.6,3.2,0.2,4.3-0.9l0.3-0.3L25.2,26.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M24.9,24.9l3.9,3.9c0.2,0.1,0.3,0.1,0.5,0c0.1-0.2,0.1-0.4,0-0.6l-5.8-5.7H23c-0.1,0.1-0.1,0.4,0,0.5 L24.9,24.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M10.2,10.2L16,16c0.2,0.1,0.3,0.1,0.5,0c0.2-0.2,0.2-0.4,0-0.5l-5.7-5.8h-0.6c0,0.1-0.1,0.2,0,0.3V10.2z"
}));

function SvgTelephony(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephony);
export default __webpack_public_path__ + "static/media/telephony.9e89d894a68767b27f65e74b0781bed9.svg";
export { ForwardRef as ReactComponent };